class QuickAddTrigger extends HTMLElement {
  constructor () {
    super()

    this.isOpen = false
    this.sectionId = 'quick-add'
  }

  connectedCallback() {
    this.els = {
      trigger: this.querySelector('[data-quick-add-trigger-el="trigger"]'),
    }

    this.externalEls = {
      body: document.querySelector('[data-quick-add-el="body"]'),
      title: document.querySelector('[data-quick-add-el="title"]'),
      dialog: document.querySelector('[data-quick-add-el="dialog"]'),
      close: document.querySelectorAll('[data-quick-add-el="close"]'),
      trigger: document.querySelector('[data-quick-add-el="trigger"]'),
      backdrop: document.querySelector('[data-quick-add-el="backdrop"]'),
    }

    this.setupEventListeners()
  }

  setupEventListeners() {
    this.addEventListener('click', this.handleTrigger.bind(this))

    this.externalEls.close.forEach(button => {
      button.addEventListener('click', this.closeDrawer.bind(this))
    })

    this.externalEls.dialog.addEventListener('click', (event) => {
      if (event.target === this.externalEls.dialog) {
        this.closeDrawer()
      }
    })
  }

  async handleTrigger(event) {
    const trigger = event.target.closest(
      '[data-quick-add-trigger-el="trigger"], [data-quick-add-el="trigger"]',
    )

    if (!trigger) return

    try {
      const response = await fetch(
        `${Shopify.routes.root}products/${this.dataset.productHandle}?section_id=${this.sectionId}`,
      )

      if (!response.ok) throw new Error("Network response was not ok")

      this.externalEls.title.textContent = this.dataset.productTitle

      const sectionHTML = await response.text()
      const sectionDocument = new DOMParser().parseFromString(sectionHTML, 'text/html')
      const innerHTML = sectionDocument.querySelector('.prd-QuickAdd')
      this.externalEls.body.innerHTML = innerHTML.outerHTML

      if (this.isOpen) return

      this.openDrawer()
    } catch (error) {
      this.closeDrawer()
    }
  }

  openDrawer() {
    this.isOpen = true

    document.body.style.overflow = 'hidden'

    this.externalEls.dialog.showModal()
  }

  closeDrawer() {
    this.isOpen = false

    document.body.style.overflow = ''

    this.externalEls.dialog.close()
  }
}

customElements.define('quick-add-trigger', QuickAddTrigger)
